import React from "react";
export const SvgIcon = (props) => {
    const { iconId, cssClass = "" } = props;
    return (<svg className={`svg-icon svg-icon-text ${cssClass}`} aria-hidden="true" focusable="false">
            <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref={`#${iconId}`}></use>
        </svg>);
};
